export const headers = {
    'content-type': "application/json",
    "Accept": "application/json, text/plain, */*",
};

export const baseUrl = "http://localhost:";

let uploadFileNativePath="http://65.1.209.204:10002/static/";

export const getUploadedFileNativePath = () => {
    return uploadFileNativePath;
}
  